export default {
  CHECKBOX: "b2304607-fd15-440b-b208-b9014fbf7773",
  INFOTEXT: "3e98e344-6e80-44c1-b65b-cbd146ef7e04",
};
